export class EntityType {
  Id?: number;
  RecordId?: number;
  Name: string;
  Number: string;
  IsDeleted: boolean;

  constructor(obj?: Partial<EntityType>) {
    if (obj) {
      Object.assign(this, obj);
    } else {
      throw Error('Object cannot be null');
    }
  }

  isSoftDeleted(): boolean {
    return this.IsDeleted;
  }
}
